import { render } from "./intro.vue?vue&type=template&id=5c6feae2&scoped=true"
import script from "./intro.vue?vue&type=script&lang=js"
export * from "./intro.vue?vue&type=script&lang=js"

import "./intro.vue?vue&type=style&index=0&id=5c6feae2&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6feae2"]])

export default __exports__